<nav>
    <input type="checkbox" id="menu-toggle">
    <div class="logo web">
        <a routerLink="/"><img src="../../../assets/img/logo/256px.png" height="64px" width="64px" alt="Logo Tropik Art"></a>
    </div>
    <label for="menu-toggle" class="menu-icon">
        <span></span>
        <span></span>
        <span></span>
    </label>
    <ul class="menu">
        <li><a routerLink="/about">À propos</a></li>
        <li><a routerLink="/gallery/image">Images</a></li>
        <li><a routerLink="/gallery/video">Vidéos</a></li>
        <li><a routerLink="/contact">Contact</a></li>
        <li class="logo mobile">
            <a routerLink="/"><img src="../../../assets/img/logo/256px.png" height="128px" width="128px" alt="Logo Tropik Art"></a>
        </li>
        <li><a [routerLink]="'/shop'" [queryParams]="{ category: 'null' }">Boutique</a></li>
        <li><a [routerLink]="'/shop'" [queryParams]="{ category: 'learning' }">Formation</a></li>
        <li><a routerLink="/account">Mon compte</a></li>
        <li><a routerLink="/cart">Panier</a></li>
    </ul>
</nav>